"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M2.06104 4.49241L3.37804 7.63241C3.47804 7.86841 3.66304 8.05641 3.89504 8.15941L7.57704 9.77041C7.77504 9.85741 7.77504 10.1424 7.57704 10.2294L3.89504 11.8414C3.66304 11.9434 3.47804 12.1324 3.37804 12.3684L2.06104 15.5084C1.74804 16.4374 2.69604 17.2954 3.60204 16.9024L17.401 10.9194C18.2 10.5734 18.2 9.42741 17.401 9.08141L3.60204 3.09741C2.69604 2.70541 1.74804 3.56241 2.06104 4.49241Z",
    fill: "#727B7F"
  }));
};